const trimTrailingSlashes = (value) => value.replace(/\/+$/, "");

const normalizeBackendUrl = (value) => {
  const rawUrl = trimTrailingSlashes(value || "");
  if (!rawUrl || rawUrl.includes("your-app-name.onrender.com")) {
    return "";
  }

  return rawUrl.endsWith("/api") ? rawUrl.slice(0, -4) : rawUrl;
};

export const BACKEND_URL = normalizeBackendUrl(process.env.REACT_APP_BACKEND_URL);

export const API_BASE_URL = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
